import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Logo } from './Logo';
import { MenuIcon, BellIcon, PlusIcon } from 'lucide-react';
import { MobileMenu } from './MobileMenu';
import { useBusiness } from './BusinessContext';
export function MobileHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    hub,
    subscribed,
    currentPlanId
  } = useBusiness();
  const [menuOpen, setMenuOpen] = useState(false);
  const isBusinessHub = location.pathname.startsWith('/business');
  const headerTitle = isBusinessHub ? hub?.name || 'Business Hub' : null;
  const planTag = isBusinessHub && subscribed ? currentPlanId : null;
  const startNewRequest = () => navigate('/', {
    state: {
      reset: Date.now()
    }
  });
  return <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-slate-100 px-4 pt-12 pb-3 flex-shrink-0" data-id="element-1947">
      <div className="flex items-center justify-between" data-id="element-1948">
        {/* Left: menu + logo/title */}
        <div className="flex items-center gap-2" data-id="element-1949">
          <button onClick={() => setMenuOpen(true)} aria-label="Open menu" className="p-2 -ml-1 hover:bg-slate-100 rounded-full transition-colors" data-id="element-1950">
            <MenuIcon className="w-5 h-5 text-slate-600" data-id="element-1951" />
          </button>
          {isBusinessHub ? <div className="flex items-center gap-2 min-w-0" data-id="element-1952">
              <h1 className="font-display font-bold text-lg text-dark-navy tracking-tight truncate max-w-[150px]" data-id="element-1953">
                {headerTitle}
              </h1>
              {planTag && <span className="flex-shrink-0 px-2 py-0.5 bg-primary-indigo/10 text-primary-indigo text-[11px] font-bold rounded-full uppercase tracking-wide" data-id="element-1954">
                  {planTag}
                </span>}
            </div> : <Logo size="sm" data-id="element-1955" />}
        </div>

        {/* Right: New request + notifications */}
        <div className="flex items-center gap-2" data-id="element-1956">
          {!isBusinessHub && <button onClick={startNewRequest} aria-label="New request" className="group inline-flex items-center gap-1.5 pl-1.5 pr-3 py-1.5 rounded-full bg-white border border-slate-200/80 text-dark-navy text-[12.5px] font-semibold shadow-[0_1px_2px_rgba(15,23,42,0.04)] hover:border-primary-indigo/30 hover:shadow-[0_2px_8px_rgba(79,70,229,0.10)] active:scale-[0.97] transition-all" data-id="element-1957">
              <span className="flex items-center justify-center w-5 h-5 rounded-full bg-primary-indigo/10 text-primary-indigo transition-colors group-hover:bg-primary-indigo group-hover:text-white" data-id="element-1958">
                <PlusIcon className="w-3 h-3" strokeWidth={2.75} data-id="element-1959" />
              </span>
              New
            </button>}
          <button aria-label="Notifications" className="p-2 hover:bg-slate-100 rounded-full transition-colors" data-id="element-1960">
            <BellIcon className="w-5 h-5 text-slate-600" data-id="element-1961" />
          </button>
        </div>
      </div>

      <MobileMenu open={menuOpen} onClose={() => setMenuOpen(false)} data-id="element-1962" />
    </header>;
}